<template>
  <layout>
    <template slot="header">Change access</template>
    <v-form style="height: 100%; overflow: auto" ref="form">
      <v-select
        :menu-props="{ bottom: true, offsetY: true }"
        data-test-rights="editors"
        item-value="id"
        item-text="name"
        label="Editors group"
        v-model="editorgroup"
        :items="dropdownRightsEditor"
        class="px-4"
      >
        <template v-slot:item="item">
          <div :data-test-edit-rights="item.item.name">
            {{ item.item.name }}
          </div>
        </template>
      </v-select>
      <v-select
        :menu-props="{ bottom: true, offsetY: true }"
        data-test-rights="users"
        label="Users group"
        item-value="id"
        item-text="name"
        v-model="usergroup"
        :items="dropdownRights"
        class="px-4"
      >
        <template v-slot:item="item">
          <div :data-test-user-rights="item.item.name">
            {{ item.item.name }}
          </div>
        </template>
      </v-select>
      <v-select
        :menu-props="{ bottom: true, offsetY: true }"
        data-test-rights="reader"
        label="Readers group"
        item-value="id"
        item-text="name"
        v-model="readergroup"
        :items="dropdownRights"
        class="px-4"
      >
        <template v-slot:item="item">
          <div :data-test-reader-rights="item.item.name">
            {{ item.item.name }}
          </div>
        </template>
      </v-select>
    </v-form>
    <template slot="footer">
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')">Cancel</v-btn>
      <v-btn color="primary" text @click="saveHandler" :loading="loading">
        save
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import { onMounted, reactive, ref, toRefs } from '@vue/composition-api';
import useGroups from '@/api/users/groups';
import isEqual from 'lodash.isequal';

export default {
  name: 'EditRightsGroup',
  components: { Layout },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    entity: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const dropdownRightsEditor = ref([]);
    const dropdownRights = ref([]);
    const { groups } = useGroups;
    let originalState = null;
    let state = reactive({
      editorgroup: '',
      usergroup: '',
      readergroup: ''
    });

    onMounted(() => {
      groups.load().then(res => {
        dropdownRightsEditor.value = res.map(item => ({
          ...item,
          disabled: item.name === 'Nobody'
        }));
        dropdownRights.value = res;
      });

      if (props.entity) {
        state.editorgroup = props.entity.editorgroup;
        state.usergroup = props.entity.usergroup;
        state.readergroup = props.entity.readergroup;

        originalState = {
          editorgroup: props.entity.editorgroup,
          usergroup: props.entity.usergroup,
          readergroup: props.entity.readergroup
        };
      }
    });
    const saveHandler = async () => {
      let newState = {
        editorgroup: state.editorgroup,
        usergroup: state.usergroup,
        readergroup: state.readergroup
      };
      if (isEqual(originalState, newState)) {
        emit('close');
      } else {
        emit('save', { ...state });
      }
    };

    return {
      ...toRefs(state),
      dropdownRights,
      dropdownRightsEditor,
      saveHandler
    };
  }
};
</script>
